<script lang="ts">
  import { userStore } from "../../stores/auth.store";
  import Button from "../../components/Button.svelte";

  function sayHello() {
    alert("Hello from Leave2Give Dashboard! 👋");
  }

  function handleLogout() {
    // You can add logout logic here if needed
    console.log("Logout clicked");
  }
</script>

<div class="dashboard-container">
  <div class="welcome-section">
    <h1>Welcome to Leave2Give Dashboard!</h1>
    {#if $userStore}
      <p class="user-greeting">
        Hello, <strong>{$userStore.email}</strong>! 
        {#if $userStore.full_name}
          ({$userStore.full_name})
        {/if}
      </p>
    {:else}
      <p class="user-greeting">Hello, User!</p>
    {/if}
  </div>

  <div class="action-section">
    <div class="hello-button">
      <Button 
        on:click={sayHello}
        variant="primary"
      >
        👋 Say Hello!
      </Button>
    </div>

    <div class="button-group">
      <Button 
        variant="secondary"
        on:click={() => window.location.href = '#/donations'}
      >
        📝 View Donations
      </Button>

      <Button 
        variant="text"
        on:click={handleLogout}
      >
        🚪 Logout
      </Button>
    </div>
  </div>

  <div class="info-section">
    <div class="info-card">
      <h3>🎯 Quick Start</h3>
      <p>Welcome to your Leave2Give dashboard. This is a simplified version to get you started!</p>
    </div>

    <div class="info-card">
      <h3>🚀 Next Steps</h3>
      <ul>
        <li>Explore the navigation menu</li>
        <li>Check out the donations section</li>
        <li>Update your profile</li>
      </ul>
    </div>
  </div>
</div>

<style>
  .dashboard-container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1.5rem;
    min-height: calc(100vh - 4rem);
  }

  .welcome-section {
    text-align: center;
    margin-bottom: 0;
  }

  .welcome-section h1 {
    font-size: 2.5rem;
    color: var(--color-primary, #3b82f6);
    margin-bottom: 1rem;
    font-weight: 700;
  }

  .user-greeting {
    font-size: 1.2rem;
    color: var(--color-text-secondary, #666);
    margin: 0;
  }

  .action-section {
    text-align: center;
    margin-bottom: 0;
  }

  .hello-button {
    margin-bottom: 2rem;
  }

  .hello-button :global(button) {
    font-size: 1.2rem;
    padding: 1rem 2rem;
    min-height: 50px;
  }

  .button-group {
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin-top: 2rem;
    flex-wrap: wrap;
  }

  .info-section {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
    margin-top: 0;
  }

  .info-card {
    background: var(--color-card-bg, #ffffff);
    border: 1px solid var(--color-border, #e5e7eb);
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease;
  }

  .info-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .info-card h3 {
    margin: 0 0 1rem 0;
    color: var(--color-primary, #3b82f6);
    font-size: 1.3rem;
  }

  .info-card p {
    color: var(--color-text-secondary, #666);
    line-height: 1.6;
    margin: 0;
  }

  .info-card ul {
    color: var(--color-text-secondary, #666);
    line-height: 1.6;
    margin: 0;
    padding-left: 1.2rem;
  }

  .info-card li {
    margin-bottom: 0.5rem;
  }

  /* Dark mode support */
  :global(.dark) .info-card {
    background: var(--color-card-bg-dark, #1f2937);
    border-color: var(--color-border-dark, #374151);
  }

  :global(.dark) .user-greeting,
  :global(.dark) .info-card p,
  :global(.dark) .info-card ul {
    color: var(--color-text-secondary-dark, #d1d5db);
  }

  :global(.dark) .welcome-section h1 {
    color: var(--color-primary-dark, #60a5fa);
  }

  /* Responsive design */
  @media (max-width: 768px) {
    .dashboard-container {
      padding: 1rem;
    }

    .welcome-section h1 {
      font-size: 2rem;
    }

    .button-group {
      flex-direction: column;
      align-items: center;
    }

    .info-section {
      grid-template-columns: 1fr;
    }
  }
</style>
